// Routes are registered via router bundles; no local addRoute here.
import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const PhishTitanModule = ({ registerNavItems }) => {
  // Routes are already registered via router/routes/mspRoutes.js & customerRoutes.js

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { PhishTitanModule };

export default {};
